import { TableCell as MuiTableCell } from "@mui/material";
import { styled } from "@mui/system";

export const TableCell = styled(MuiTableCell)({ padding: "0.5rem" });
